import React from 'react';
import { useParams } from 'react-router-dom';
import PFNominationForm from './PFNominationForm';
import FamilyDetailsForm from './FamilyDetailsForm';
import MarriageDeclarationForm from './MarriageDeclarationForm';
import RelationshipDeclarationForm from './RelationshipDeclarationForm';

export default function FormRenderer() {
  const { formCode } = useParams();

  switch (formCode) {
    case 'PF_NOM':
      return <PFNominationForm />;
    case 'FAMILY':
      return <FamilyDetailsForm />;
    case 'MARR_DECL':
      return <MarriageDeclarationForm />;
    case 'REL_DECL':
      return <RelationshipDeclarationForm />;
    default:
      return (
        <div className="max-w-4xl mx-auto px-6 py-8">
          <div className="flex items-center justify-center py-12">
            <div className="text-gray-500">Form not found</div>
          </div>
        </div>
      );
  }
}
